import styled from "styled-components";

const DivButtonAdvance = styled.div`
  text-align: right;
  margin: 32px 0;
  padding-right: 30px;
`;

export { DivButtonAdvance };
